angular.module('impactx.basket').controller('BasketForwardDialogCtrl', BasketForwardDialogCtrl);

BasketForwardDialogCtrl.$inject = ['$scope', 'dataGen', '$mdDialog', 'themeFactory', 'TranslationService', 'bkhId'];

function BasketForwardDialogCtrl($scope, dataGen, $mdDialog, themeFactory, TranslationService, bkhId)
{
    var ctrl = this;

    $scope.theme = themeFactory.getTheme();
    $scope.applyLabel = TranslationService.get('save');
    $scope.abortLabel = TranslationService.get('abort');

    dataGen.getData($scope, {bkhId: bkhId}, "/basket/forward/view");

    ctrl.apply = function() {
        dataGen.postAsForm($scope, {data: $scope.data}, "/basket/forward/save").then(function () {
            $mdDialog.hide();
        });
    };

    ctrl.cancel = function(){
        $mdDialog.cancel();
    };
}